import { REPATRIATIONS_TRANSACTIONS_OBJECT_REQUEST, REPATRIATIONS_TRANSACTIONS_OBJECT_SUCCESS, REPATRIATIONS_TRANSACTIONS_OBJECT_FAILURE } from './types/RepatriationsTransactionsObjectActionsTypes';

export function postRepatriationsTransactionsObjectRequestActionCreator(context,
  newDescription,
  newQuantity,
  newTransactionId) {
  return {
    type: REPATRIATIONS_TRANSACTIONS_OBJECT_REQUEST,
    payload: {
      appContext: context,
      params: {
        comments: newDescription,
        quantity: newQuantity,
        transactionId: newTransactionId,
      },
    },
  };
}

export function postRepatriationsTransactionsObjectSuccessActionCreator(data) {
  return {
    type: REPATRIATIONS_TRANSACTIONS_OBJECT_SUCCESS,
    payload: data,
  };
}

export function postRepatriationsTransactionsObjectFailureActionCreator(error) {
  return {
    type: REPATRIATIONS_TRANSACTIONS_OBJECT_FAILURE,
    payload: error,
    error: true,
  };
}
